import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, NavigationButtons } from './styles';
import ActivitiesList from 'features/Activities/pages/List';
import DestinationsCarousel from 'features/Destinations/pages/DestinationsCarousel';
import MainTitle from 'components/MainTitle';
import IHomeData from 'interfaces/IHomeData';
import IDestination from 'interfaces/IDestination';
import { useLoading } from 'hooks/useLoading';
import PublicService from 'services/PublicService';
import TourismList from 'common/Tourism/index';

const HandleTab = (): JSX.Element => {
  const location = useLocation();

  const getInitialExperience = () => {
    const params = new URLSearchParams(location.search);
    return params.get('experience');
  };

  const [data, setHomeData] = useState<IHomeData | undefined>();
  const [selectedExperience, setSelectedExperience] = useState<string | null>(getInitialExperience);
  const [destination, setDestination] = useState<Partial<IDestination> | undefined>();
  const { openLoading, closeLoading } = useLoading();

  const getData = async () => {
    try {
      openLoading();
      const service = new PublicService();
      const [homeData, events] = await Promise.all([
        service.getHomeData(),
        service.getAllEvents(),
        service.getDestination('o-que-fazer').then(setDestination),
      ]);
      setHomeData({ ...homeData, events });
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    } finally {
      closeLoading();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  // Auto-seleciona o primeiro vetor ao carregar as experiências,
  // caso nenhum filtro tenha sido definido via URL ou interação do usuário
  useEffect(() => {
    if (data?.experiences && data.experiences.length > 0 && selectedExperience === null) {
      setSelectedExperience(data.experiences[0].title);
    }
  }, [data?.experiences]);

  const handleSelectExperience = (experienceTitle: string) => {
    if (selectedExperience === experienceTitle) {
      setSelectedExperience(null);
    } else {
      setSelectedExperience(experienceTitle);
    }
  };

  // Busca os banners do carrossel da experiência selecionada,
  // ou faz fallback para os banners do destino geral 'o-que-fazer'
  const activeExperienceBanners = React.useMemo(() => {
    if (selectedExperience && data?.experiences) {
      const current = data.experiences.find(
        exp => exp.title?.trim().toLowerCase() === selectedExperience.trim().toLowerCase()
      );
      if (current?.banners && current.banners.length > 0) {
        return current.banners;
      }
    }
    return destination?.banners || [];
  }, [selectedExperience, data?.experiences, destination?.banners]);

  return (
    <>
      <MainTitle>Experiências Turísticas</MainTitle>
      {activeExperienceBanners.length > 0 && (
        <DestinationsCarousel banners={activeExperienceBanners} applyGradient={false} />
      )}
      <Container>
        <TourismList
          experiences={data?.experiences}
          selectedExperience={selectedExperience}
          onExperienceSelect={handleSelectExperience}
        />

        <NavigationButtons>
          <ActivitiesList experiences={data?.experiences} selectedExperience={selectedExperience} />
        </NavigationButtons>
      </Container>
    </>
  );
};

export default HandleTab;
